export const signIn = () => {
  return {
    slogan: 'The easiest way  to connect to your jobs for faster payment.',
    header_title: 'Contractor Log In',
    title: 'SIGN IN',
    sign_in_google: 'Sign in with Google',
    sign_in_microsoft: 'Sign in with Microsoft',
    email_address: 'Email Address',
    email_address_or_username: 'Username or email address',
    password: 'Password',
    remember_me: 'Remember me',
    forgot_password: 'Forgot password?',
    request_access: 'Request Access',
    sign_in_jumpcloud: 'Sign in with JumpCloud',
    register: 'Register',
    sign_in: 'Sign In',
    no_account: 'Don’t have an account?',
    create_account: 'Create one here',
    sso: 'SSO',
    ssoid: 'SSO ID',
    messages: {
      missing_fields: 'Both fields are required to login',
      wrong_user_password: 'Invalid credentials, please try again.',
      user_no_permission: 'User does not have permission to access the portal.',
      terms_and_conditions: 'Using the MyWork Platform, you agree to the ',
      terms_and_conditions_link: 'terms and conditions.',
      all_rights: 'All Rights Reserved.',
      privacy_policy_link: 'Privacy Policy',
      wrong_ssoid: 'The SSO ID entered is not valid. Please try again.'
    },
    masquerade: {
      title: 'Masquerade',
      mask_as: 'Masquerading as',
      subtitle: 'Select a client for masquerading to help troubleshoot issues, view work orders and manage users.',
      skip: 'Skip',
      go: 'Go',
      start: 'Start',
      search_client: 'Search Client Name',
      search_client_mobile: 'Search Client',
      frequently: 'Frequently used',
      no_frequently: 'There are no frequently used clients.',
      no_client: 'No Client Selected',
      switch: 'Switch Client',
      back: 'Back'
    },
    contact_us: 'Contact us',
    logout: {
      title: 'Your Session Ended',
      message:
        'We’re sorry but something has happened to your session. Sign in again, to ensure all your work is up to date.'
    },
    invalid_user: {
      title: 'Invalid Credentials',
      message: 'The credentials entered are not valid. Please try again.'
    }
  }
}
